import { render, staticRenderFns } from "./im_supervise.vue?vue&type=template&id=13862043&scoped=true"
import script from "./im_supervise.vue?vue&type=script&lang=ts"
export * from "./im_supervise.vue?vue&type=script&lang=ts"
import style0 from "./im_supervise.vue?vue&type=style&index=0&id=13862043&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13862043",
  null
  
)

export default component.exports